import { getPhoneNumberCountryCodeFormatted } from 'lib-shared-phone-numbers';
import { connect } from 'react-redux';

import { AppDispatch } from 'bootstrap.store';
import { AddUserPayload, userModalActions } from 'components/usersModal';
import { bindActionToPromise } from 'utils/sagaApiGeneratorHelpers';

import { addCallerActions } from '../actions/addCaller';
import AddCallerModal from '../components/addCallerModal/index';

const {
  addCallerCallRequest,
  addCallerGetUsersByQuery,
  addCallerModalClose,
  addCallerResetUsers,
} = addCallerActions;

const DEFAULT_PREFIX = 45;

function fromNumberCountryCode(selectedFromNumber: any) {
  if (!selectedFromNumber) {
    return DEFAULT_PREFIX;
  }

  return (
    getPhoneNumberCountryCodeFormatted(selectedFromNumber.e164_format) ||
    DEFAULT_PREFIX
  );
}

const mapStateToProps = (state: any) => {
  const selectedFromNumber = state.telephony.selectedFromNumber;

  return {
    meta: state.addCaller.meta,
    ui: state.addCaller.ui,
    users: state.addCaller.users,
    metaConversation: state.addCaller.metaConversation,

    profileMeta: state.settings.profile.meta,
    presenceMeta: state.presence.meta,
    profile: state.settings.profile.profile,

    fromNumberCountryCode: fromNumberCountryCode(selectedFromNumber),
  };
};

const mapDispatchToProps = (dispatch: AppDispatch) => {
  return {
    addCallerRequest: bindActionToPromise(dispatch, addCallerCallRequest),
    userModalAddUser: (payload: AddUserPayload) =>
      dispatch(userModalActions.user.add(payload)),
    getUsersByQuery: (payload) => dispatch(addCallerGetUsersByQuery(payload)),
    addCallerResetUsers: () => dispatch(addCallerResetUsers()),
    addCallerModalClose: () => dispatch(addCallerModalClose()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddCallerModal as any);
